import { render, staticRenderFns } from "./VeeRichTextEditor.vue?vue&type=template&id=3a04f58c&scoped=true&"
import script from "./VeeRichTextEditor.vue?vue&type=script&lang=js&"
export * from "./VeeRichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./VeeRichTextEditor.vue?vue&type=style&index=0&id=3a04f58c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04f58c",
  null
  
)

export default component.exports